import React from 'react';
import styles from './landing-page.module.css';

interface LandingPageProps {
  onLogin: () => void;
  onRegister?: () => void;
}

export const LandingPage: React.FC<LandingPageProps> = ({ onLogin, onRegister }) => {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.logo}>
          Cyber<span>Novel</span>
          <div className={styles.logoDot} />
        </div>
        <div className={styles.navActions}>
          {onRegister && (
            <button onClick={onRegister} className={styles.secondaryBtn}>Créer un compte</button>
          )}
          <button onClick={onLogin} className={styles.secondaryBtn}>Connexion</button>
        </div>
      </header>

      <main className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.title}>
            L'immersion au service de la <span>Cyber-résilience</span>
          </h1>
          <p className={styles.description}>
            Vivez des histoires interactives où vos décisions impactent la sécurité de votre organisation. 
            Une expérience narrative unique pour maîtriser les enjeux de la cybersécurité.
          </p>
          <div className={styles.actions}>
            {onRegister && (
              <button onClick={onRegister} className={styles.secondaryBtn}>
                Créer un compte
              </button>
            )}
            <button onClick={onLogin} className={styles.ctaBtn}>
              Se connecter
              <span className={styles.arrow}>→</span>
            </button>
          </div>
        </div>
        <div className={styles.heroImage}>
          {/* Placeholder for a cool visual or animation */}
          <div className={styles.visualCard}>
            <div className={styles.cardHeader}>
              <div className={styles.cardDot} />
              <div className={styles.cardDot} />
              <div className={styles.cardDot} />
            </div>
            <div className={styles.cardContent}>
              <div className={styles.line} style={{ width: '80%' }} />
              <div className={styles.line} style={{ width: '60%' }} />
              <div className={styles.line} style={{ width: '90%', background: 'rgba(74, 158, 255, 0.4)' }} />
              <div className={styles.line} style={{ width: '40%' }} />
            </div>
          </div>
        </div>
      </main>

      <section className={styles.features}>
        <div className={styles.feature}>
          <div className={styles.featureIcon}>📖</div>
          <h3>Récits Interactifs</h3>
          <p>Plongez dans des scénarios réalistes et faites face à des dilemmes complexes.</p>
        </div>
        <div className={styles.feature}>
          <div className={styles.featureIcon}>🛡️</div>
          <h3>Apprentissage Actif</h3>
          <p>Apprenez par la pratique et l'expérimentation dans un environnement sûr.</p>
        </div>
        <div className={styles.feature}>
          <div className={styles.featureIcon}>📊</div>
          <h3>Suivi de Progression</h3>
          <p>Mesurez votre montée en compétences grâce à nos indicateurs de performance.</p>
        </div>
      </section>

      <footer className={styles.footer}>
        <p>© 2026 CyberNovel - Propulsé par <a href="https://darwin-x.com" target="_blank" rel="noopener noreferrer">Darwin X</a></p>
      </footer>
    </div>
  );
};
